import { CREATE_CRQ } from 'AppSrc/core/components/create-crq-screen/create-crq-screen-consts';
import {
  MOBILE,
  FIXED,
  FIXEDOLO,
  INTERNATIONAL,
} from 'AppSrc/core/components/forms/value-dependency-constants';


const humaniseNetwork = {
  [MOBILE]: 'Mobile',
  [FIXED]: 'Fixed',
  [FIXEDOLO]: 'Fixed OLO',
  [INTERNATIONAL]: 'Fixed International',
};


const getHeaderText = ({
  formType,
  selectedNetwork,
  crqId,
  IsOlaCrq,
  isIcmCrq,
}) => {

  if (crqId && IsOlaCrq) {
    return `${crqId} (${humaniseNetwork[IsOlaCrq ? FIXEDOLO : selectedNetwork]})`;
  }

  if (crqId && isIcmCrq) {
    return `${crqId} (${humaniseNetwork[isIcmCrq ? INTERNATIONAL : selectedNetwork]})`;
  }

  if (crqId && selectedNetwork) {
    return `${crqId} (${humaniseNetwork[selectedNetwork]})`;
  }

  if (formType === CREATE_CRQ && isIcmCrq) {
    return `Create ${selectedNetwork ? `${humaniseNetwork[isIcmCrq ? INTERNATIONAL : selectedNetwork]} ` : ''} CRQ`;
  }

  if (formType === CREATE_CRQ) {
    return `Create ${selectedNetwork ? `${humaniseNetwork[IsOlaCrq ? FIXEDOLO : selectedNetwork]} ` : ''} CRQ`;
  }

  return 'Form'; // fall back
};


export { getHeaderText };
